import React, { useContext, useEffect } from "react";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Team from '../components/team/team_body';
import Topbar from '../components/Topbar';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  // 🔁 載入語言檔（每次語系變動就會重新載入）
  useEffect(() => {
    loadLanguageFile("Team", "team/team_body_lang");
  }, [language]);

  // ✅ 安全讀取語言內容
  const LANGUAGE = componentLanguageData.Team || { Main: {}, Experience: {}, Expertise: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <Team />
    </div>
  );
};

export default Page;